import { createFileRoute } from "@tanstack/react-router";
import { SERVICE_BY_SLUG } from "@/lib/services";
import { ServicePageTemplate } from "@/components/site/ServicePageTemplate";
import { faqSchema, serviceSchema, breadcrumbSchema } from "@/components/site/SchemaJsonLd";

const service = SERVICE_BY_SLUG["kitchen-and-bathroom-plumbing"];

export const Route = createFileRoute("/kitchen-and-bathroom-plumbing")({
  head: () => ({
    meta: [
      { title: service.title },
      { name: "description", content: service.description },
      { property: "og:title", content: service.title },
      { property: "og:description", content: service.description },
      { property: "og:url", content: "https://www.phoenixplumbing.co/kitchen-and-bathroom-plumbing" },
      { name: "twitter:title", content: service.title },
      { name: "twitter:description", content: service.description },
    ],
    links: [{ rel: "canonical", href: "https://www.phoenixplumbing.co/kitchen-and-bathroom-plumbing" }],
    scripts: [
      { type: "application/ld+json", children: JSON.stringify(serviceSchema(service.name, service.description)) },
      { type: "application/ld+json", children: JSON.stringify(faqSchema(service.faqs)) },
      { type: "application/ld+json", children: JSON.stringify(breadcrumbSchema([{ name: "Home", url: "/" }, { name: "Kitchen & Bathroom Plumbing", url: "/kitchen-and-bathroom-plumbing" }])) },
    ],
  }),
  component: () => <ServicePageTemplate service={service} />,
});
